<template>
    <div>
        <div class="mt-2 space-x-4 flex" v-if="options.length > 0">
            <div class="bg-gray-light border border-gray-dark flex rounded-md shadow-sm">
                <div class="flex items-center px-2">
                    <label for="labels" class="sr-only">Select a folder</label>
                    <select id="labels" name="labels" class="p-2 bg-transparent border-transparent h-full rounded-md sm:text-sm outline-none font-bold" v-model="variables.id">
                        <option>Select a folder</option>
                        <option v-for="label in options" :key="label.id" :value="label.id">{{ label.name }}</option>
                    </select>
                </div>
                <div class="flex-1"></div>
            </div>
        </div>
        <div class="mt-2 space-x-4 flex" v-else>
            Loading...
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            options: [],
            name: 'folder',
            variables: {
                id: '',
            },
        }
    },
    mounted() {
        this.syncData();
        this.getLabels();
    },
    watch: {
        $data: {
            handler() {
                this.syncData();
            },
            deep: true,
        }
    },
    methods: {
        syncData() {
            this.$emit('change', {
                name     : this.name,
                variables: this.variables,
            });
        },
        getLabels() {
            axios.get('/api/mailbox?includes=labels')
                .then(response => {
                    const { data: { data: { labels } } } = response;
                    this.options = labels;
                })
                .catch(console.error);
        },
    }
}
</script>

<style>

</style>